'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _cache = require('../utilities/cache');

var _cache2 = _interopRequireDefault(_cache);

var _debounce = require('../utilities/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {};

var validatorFor = function validatorFor(options, key) {
	if (!options.debounce) {
		return options.validate;
	}

	var validatorKey = 'key:' + key + '_function-name:' + options.validate.name;
	var validator = validators[validatorKey];
	if (validator && validator.options.validate === options.validate) {
		return validator.validate;
	}

	validators[validatorKey] = {
		options: options,
		validate: (0, _debounce2.default)(options.validate, options.debounce.duration)
	};
	return validators[validatorKey].validate;
};

var asyncValidator = function () {
	var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(value, options, key) {
		var validator;
		return _regenerator2.default.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (!(typeof options.validate === 'function')) {
							_context.next = 17;
							break;
						}

						validator = validatorFor(options, key);
						_context.prev = 2;

						if (!options.cache) {
							_context.next = 7;
							break;
						}

						_context.next = 6;
						return (0, _cache2.default)(validator, key, value, options.cache.duration);

					case 6:
						return _context.abrupt('return', _context.sent);

					case 7:
						_context.next = 9;
						return validator(value);

					case 9:
						return _context.abrupt('return', _context.sent);

					case 12:
						_context.prev = 12;
						_context.t0 = _context['catch'](2);

						if (!options.debounce) {
							_context.next = 16;
							break;
						}

						return _context.abrupt('return', undefined);

					case 16:
						throw _context.t0;

					case 17:
						return _context.abrupt('return', undefined);

					case 18:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined, [[2, 12]]);
	}));

	return function asyncValidator(_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	};
}();

var _default = asyncValidator;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(validators, 'validators', 'src/validators/asyncValidator.js');

	__REACT_HOT_LOADER__.register(validatorFor, 'validatorFor', 'src/validators/asyncValidator.js');

	__REACT_HOT_LOADER__.register(asyncValidator, 'asyncValidator', 'src/validators/asyncValidator.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/validators/asyncValidator.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/validators/asyncValidator.js